import React from "react";
import PropTypes from "prop-types";
import iconThuGon from "Resources/Images/thugon_18_50.gif";
import { Cookies } from "react-cookie";
import { getUrl, getPhienBan, getUserLogin, getDomain } from "utils/utils";

class PanelLeft extends React.Component {
  constructor(props) {
    super(props);
    const cookies = new Cookies();
    const token = cookies.get("userTokenDaiLy");
    this.state = {
      showing: true,
      url: getUrl(),
      sPhienBan: getPhienBan(),
      objUser: getUserLogin(),
      lstMenuThuongDung: [],
      urlAPI: getDomain(),
    };
  }

  componentWillMount() {
    // fetch(
    //   this.state.urlAPI +
    //   "lichsuview/loadMenuThuongDung?sUserName=" +
    //   this.state.objUser.UserName,
    //   {
    //     headers: {
    //       Authorization: this.state.token.substring(6) // dùng token tại đây
    //     }
    //   }
    // )
    //   .then((response) => response.json())
    //   .then((data) => {
    //     this.setState({ lstMenuThuongDung: data });
    //   });
  }
  buildUrl(str) {
    window.location.href = this.state.url + str;
  }
  render() {
    const { showing } = this.state;
    return (
      <div class="box_left">
        <div id="divMoreinfo8">
          <div class="menuL152">
            <div class="bgmenuL152">
              <span>Thường dùng </span>
            </div>
            <div id="divMoreinfo" class="box_bgleft">
              {this.state.lstMenuThuongDung.map((item, index) => {
                return (
                  <div class="menu_box152">
                    <div class="icon_box152">
                      <img
                        src="../Images/icon1_24_24.gif"
                        alt=""
                        width="24"
                        height="24"
                      />
                    </div>
                    <div class="Text_box152">
                      {item.IsASP == true && (
                        <a href={this.state.url + item.ViewUrl}>
                          {item.ViewName}
                        </a>
                      )}
                      {item.IsASP == false && (
                        <a href={item.ViewUrl}>{item.ViewName}</a>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          <div class="menuL152">
            <div class="bgmenuL152">
              <div class="iconmenu">
                <img
                  src="../Images/icon_20_24.gif"
                  alt=""
                  onClick={() => this.setState({ showing: !showing })}
                />
              </div>
              <span>Chức năng</span>
            </div>
            <div
              id="divMoreinfo1"
              class="box_bgleft"
              style={{ display: showing ? "block" : "none" }}
            >
              {/* <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/CongTrinh/DanhSachCongTrinh"}>
                    DS công trình
                  </a>
                </div>
              </div> */}
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Customers/Default.aspx"}>
                    Khách hàng
                  </a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Stores/Default.aspx"}>
                    Quản lý kho
                  </a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Sale/Default.aspx"}>Bán hàng</a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/TraHang/Default.aspx"}>
                    Trả hàng
                  </a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Buy/Default.aspx"}>Nhập hàng</a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Accountant/Default.aspx"}>
                    Kế toán
                  </a>
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  {this.state.sPhienBan === "Multi" ? (
                    <a href={this.state.url + "/Systems/Default.aspx"}>
                      Hệ thống
                    </a>
                  ) : (
                    <a href={this.state.url + "/System/Default.aspx"}>
                      Hệ thống
                    </a>
                  )}
                </div>
              </div>
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon4_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Sale/Diary.aspx"}>Nhật ký</a>
                </div>
              </div>
            </div>
          </div>
          <div class="menuL152">
            <div class="bgmenuL152">
              <span>cá nhân</span>
            </div>
            <div id="divMoreinfo2" class="box_bgleft">
              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon5_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href="/Users/MKNguoiDung">
                    đổi mật khẩu
                  </a>
                </div>
              </div>

              <div class="menu_box152">
                <div class="icon_box152">
                  <img
                    src="../Images/icon8_24_24.gif"
                    alt=""
                    width="24"
                    height="24"
                  />
                </div>
                <div class="Text_box152">
                  <a href={this.state.url + "/Login.aspx?Logout=true"}>thoát</a>
                </div>
              </div>
            </div>
          </div>
          <div class="footer footer-banhang">
            <div class="copyright">
              <br />
              Copyright 2010 Niemtin Media JSC.
              <br />
              All Rights Reserved
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="thugon">
          <img src={iconThuGon} />
        </div>
      </div>
    );
  }
}

PanelLeft.propTypes = {
  showBackground: PropTypes.func,
};

export default PanelLeft;
